import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";

import { MainRoute } from "../../../route/MainRoute";

import { useRequestDispatch } from "store/requestHooks";
import { FetchUserAccount, fetchUserAccount } from "store/user/user-action";

import classes from "./Main.module.scss";
import { useRootSelector } from "store";

export const Main = () => {
  const { user } = useAuth0();
  const dispatch = useRequestDispatch();
  const { notifications } = useRootSelector((state) => state.notification);

  const dismissibleCount = notifications.filter((n) => n.closable).length;
  const nonDismissibleCount = notifications.filter((n) => !n.closable).length;

  const notificationClasses = [
    classes.Main,
    dismissibleCount > 0 ? classes.WithNotification : "",
    nonDismissibleCount > 0 ? classes.WithBanner : "",
  ].filter((cls) => cls);

  useEffect(() => {
    if (!!user?.sub) {
      if (!!(window as any).dtrum) {
        try {
          (window as any).dtrum.identifyUser(user.sub);
        } catch (e) {}
      }
      dispatch<FetchUserAccount>(fetchUserAccount);
    }
    // eslint-disable-next-line
  }, [user?.sub]);

  return (
    <div role="main" className={notificationClasses.join(" ")}>
      <MainRoute />
    </div>
  );
};
